import React, { useState, useMemo } from "react"
import styled from "styled-components"
import { APP_ID } from "../../helpers/constants"
import ImagePlaceholder from "../../images/image_placeholder.jpg"
import NoImage from "../../images/no-image.png"

const ProductCardBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.2rem 1rem 0.5rem 1rem;
  width: 98%;
  background-color: #fff;
  margin: 0.2rem;
  overflow: hidden;
  @media (min-width: 411px) {
    margin: 0.3rem 0.2rem;
  }
`

const DetailsBox = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
`

const NameBox = styled.div`
  font-size: 1.2rem;
  text-align: left;
  width: 100%;
  height: 3rem;
  line-height: 120%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

const PriceBox = styled.div`
  margin-top: 0.4rem;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`

const CurrentPriceBox = styled.div`
  font-size: 1.6rem;
  color: #000;
  font-weight: 600;
  margin-right: 0.4rem;
`

const ReferencePriceBox = styled.div`
  font-size: 1.2rem;
  color: ${props => props.theme[APP_ID].secondary};
  font-weight: 300;
  text-decoration: line-through;
  transform: translateY(0.15rem);
`

const ImageWrapperBox = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 20rem;
  /* margin: 5rem 1.6rem .4rem 1.6rem; */
  margin: 0rem 1.6rem .4rem 1.6rem;

  position: relative;
  overflow: hidden;
  @media (min-width: 768px) {
    margin: 0rem 0.4rem .8rem 0.4rem;
  }
  @media (min-width: 961px) {
    margin: .4rem 0.4rem .8rem 0.4rem;
  }
`

const ImageBox = styled.img`
  display: block;
  width: 100%;
  cursor: pointer;
  z-index: 10;
`

const OOSBox = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #000;
  padding: .7rem 0;
  bottom: 10%;
  right: -34%;
  transform: rotate(-45deg);
  z-index: 20;
  opacity: .7;
`

const OOSLabel = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
`

const DiscountBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${props => props.theme[APP_ID].tertiary};
  color: #fff;
  font-size: 1.4rem;
  white-space: nowrap;
  padding: .4rem .6rem;
  z-Index: 11;
  opacity: .8;
`

export default props => {
  return (
    <ProductCardBox>
      <DetailsBox>
        <ImageWrapperBox>
          {
            props.discount >= 10 && (
              <DiscountBox>{props.discount}% OFF</DiscountBox>
            )
          }
          <CardImage
            onClick={props.onClick}
            loadingImage={ImagePlaceholder}
            mainImage={props.cardImgSrc}
            errorImage={NoImage}
          />
          {/* {props.isSoldOut && (
            <OOSBox onClick={props.onClick}>
              <OOSLabel>sold out</OOSLabel>
            </OOSBox>
          )} */}
        </ImageWrapperBox>

        <div style={{ width: "100%", position: "static", top: 0, left: 0, marginTop: ".2rem" }}>
          <NameBox>{props.productName}</NameBox>
          <PriceBox>
            <CurrentPriceBox>P{props.currentPrice}</CurrentPriceBox>
            {props.discount >= 10 && (
              <ReferencePriceBox>P{props.referencePrice}</ReferencePriceBox>
            )}
          </PriceBox>
        </div>
      </DetailsBox>
    </ProductCardBox>
  )
}


const CardImage = ({ loadingImage, mainImage, errorImage, ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const src = useMemo(() => {
    if (hasError) {
      return errorImage;
    }

    if (isLoaded) {
      return mainImage;
    }

    return loadingImage;
  }, [hasError, isLoaded])

  return (
    <ImageBox
      src={src}
      onLoad={() => setIsLoaded(true)}
      onError={() => setHasError(true)}
      {...props}
    />
  )
}